import React from "react";

export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h1 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Shopify Plus Development Services
        </h1>

        {/* Description under heading */}
        <p className="leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[20px]">
          Scaling your ecommerce brand requires more than just a beautiful storefront.
          At Mean3, we bring together strategy, performance, and design to build
          high-performing Shopify Plus experiences that are tailored for
          enterprise-level success.
        </p>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {/* Card 1 */}
          <div className="bg-[#E42E35] text-white p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%]">
            <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
              Shopify Plus Development Company That Builds for Growth
            </h2>
            <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
              We’re an Official Shopify Partner, trusted by global brands and
              fast-scaling startups alike. Our Shopify Plus team specializes in crafting
              conversion-focused storefronts for DTC brands and retailers. Whether
              you're migrating from another platform or optimizing your current store,
              we deliver scalable, high-performance solutions without compromising
              speed, UX, or flexibility.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#f5f5f5] text-[#373737] p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%]">
            <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
              Full-Service Shopify Plus Development Services
            </h2>
            <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
              We don’t just build Shopify stores, we create comprehensive ecommerce
              ecosystems built on Shopify Plus. From headless architecture and
              automation to custom checkout and cross-platform integrations, our
              solutions are engineered for long-term performance and growth.
            </p>
          </div>
        </div>
      </div>

      {/* Logos row stays same */}
      <div className="w-[90%] flex justify-center items-center section2-container mx-auto">
        <div className="mx-5">
          <img
            className="w-[120px]"
            alt="Awards Logos"
            src="/assets/go-awards-logo.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[97px]"
            alt="Awards Logos"
            src="../../../../assets/award2.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[119px]"
            alt="Awards Logos"
            src="../../../assets/secp-logo.jpg"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[116px]"
            alt="Awards Logos"
            src="/assets/pasha-logo.jpg"
          />
        </div>
      </div>
    </div>
  );
}
